import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { agentRoles, checkoutFields, clientRole, editOrders, spekwo, toastMsg } from '../../../../utils';
import * as _ from 'lodash';
/*Service File  */
import { EcommerceOrdersService } from '../../orders.service';
import { ToastComponent } from '../../../../common/toast.component';

@Component({
  selector: 'app-order-details-edit',
  templateUrl: './order-details-edit.component.html',
  styleUrls: ['./order-details-edit.component.scss']
})
export class OrderDetailsEditComponent implements OnInit {
  checkoutFields = checkoutFields;
  editOrders = editOrders;
  orderDetailsFormGroup: FormGroup;
  orderDetails: any;
  userId: string;
  nodeId: string;
  toastMsg = toastMsg;
  agentRoles = agentRoles;
  clientRoles = clientRole;
  spekwo = spekwo;
  agentType: any;
  constructor(    
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    /** MatDialog Ref */
    private dialogRef: MatDialogRef<OrderDetailsEditComponent>,
    /** Service file */
    private ordersService: EcommerceOrdersService,
    /** Local component */
    public toastComponent: ToastComponent,
    ) { }

  ngOnInit() {
    this.userId = window.localStorage.getItem('userUID'); 
    this.nodeId = this.data.nodeId;
    this.orderDetails = JSON.parse(this.data.orderContent);
    this.orderDetailsFormGroup = this.formBuilder.group({
      customerName :['', Validators.required],
      clientName:['', Validators.required],
      email:['', Validators.required],
      agentPhone:['', Validators.required],
      address:['', Validators.required],
      additialEmailToSe:['', Validators.required],
      agentType:['',],
      agentName:['',],
      agentEmail:['',],
      clientRole:['', Validators.required],
    });
    this.setValuesToEdit();
  }
  setValuesToEdit() {
    var clientName = this.orderDetails
    ? _.find(this.orderDetails.meta_data, { key: checkoutFields.clientName })
    : null; // Client Name
    var buyerProperty = this.orderDetails
    ? _.find(this.orderDetails.meta_data, { key: checkoutFields.buyerProperty })
    : null; // Buyer property
    var solEmail = this.orderDetails
    ? _.find(this.orderDetails.meta_data, { key: checkoutFields.solEmail })
    : null; // Solution Additional Email 
    var agentType = this.orderDetails
    ? _.find(this.orderDetails.meta_data, { key: checkoutFields.agentRole })
    : null; //Agent Type
    var agentName = this.orderDetails
    ? _.find(this.orderDetails.meta_data, { key: checkoutFields.agentName })
    : null; // Agent Name 
    var agentEmail = this.orderDetails
    ? _.find(this.orderDetails.meta_data, { key: checkoutFields.agentEmail })
    : null; // Agent Email 
    var clientRole = this.orderDetails
    ? _.find(this.orderDetails.meta_data, { key: checkoutFields.propertyRole })
    : null; // Client Role
    this.orderDetailsFormGroup.controls['customerName'].setValue(this.orderDetails && this.orderDetails.billing && this.orderDetails.billing.first_name ? this.orderDetails.billing.first_name : null);
    this.orderDetailsFormGroup.controls['clientName'].setValue(clientName && clientName.value ? clientName.value : null);
    this.orderDetailsFormGroup.controls['email'].setValue(this.orderDetails && this.orderDetails.billing && this.orderDetails.billing.email ? this.orderDetails.billing.email : null);
    this.orderDetailsFormGroup.controls['agentPhone'].setValue(this.orderDetails && this.orderDetails.billing && this.orderDetails.billing.phone ? this.orderDetails.billing.phone : null);
    this.orderDetailsFormGroup.controls['address'].setValue(buyerProperty && buyerProperty.value ? buyerProperty.value : null);
    this.orderDetailsFormGroup.controls['additialEmailToSe'].setValue(solEmail && solEmail.value ? solEmail.value :null);
    this.orderDetailsFormGroup.controls['agentType'].setValue(agentType && agentType.value ? agentType.value : null);
    this.agentType = agentType && agentType.value ? agentType.value : null;
    this.orderDetailsFormGroup.controls['agentName'].setValue(agentName && agentName.value ? agentName.value : null);
    this.orderDetailsFormGroup.controls['agentEmail'].setValue(agentEmail && agentEmail.value ? agentEmail.value : null);
    this.orderDetailsFormGroup.controls['clientRole'].setValue(clientRole && clientRole.value ? clientRole.value : null);   
  }
  saveEdit(){
    this.orderDetails.meta_data.forEach((element,key) => {
      if (element.key == checkoutFields.solEmail){
        this.orderDetails.meta_data[key].value = this.orderDetailsFormGroup.getRawValue().additialEmailToSe;
      }
      if (element.key == checkoutFields.buyerProperty){
        this.orderDetails.meta_data[key].value = this.orderDetailsFormGroup.getRawValue().address;
      }
      if (element.key == checkoutFields.clientName){
        this.orderDetails.meta_data[key].value = this.orderDetailsFormGroup.getRawValue().clientName;
      }
      if (element.key == checkoutFields.agentRole){
        this.orderDetails.meta_data[key].value = this.orderDetailsFormGroup.getRawValue().agentType;
      }
      if (element.key == checkoutFields.agentName){
        this.orderDetails.meta_data[key].value = this.orderDetailsFormGroup.getRawValue().agentName;
      }
      if (element.key == checkoutFields.agentEmail){
        this.orderDetails.meta_data[key].value = this.orderDetailsFormGroup.getRawValue().agentEmail;
      }
      if (element.key == checkoutFields.propertyRole){
        this.orderDetails.meta_data[key].value = this.orderDetailsFormGroup.getRawValue().clientRole;
      }
    });
    this.orderDetails.billing.email = this.orderDetailsFormGroup.getRawValue().email;
    this.orderDetails.billing.phone = this.orderDetailsFormGroup.getRawValue().agentPhone;
    this.orderDetails.billing.first_name = this.orderDetailsFormGroup.getRawValue().customerName;
    let finalOrderInfo = JSON.stringify(this.orderDetails);
    //Modal Response Sends to Order Details Page
    this.dialogRef.close(this.orderDetailsFormGroup.getRawValue());
    //update order value in DB query Call 
    this.ordersService.editOrder(this.nodeId,this.userId,finalOrderInfo).then((editRes) =>{
      this.showToast('success');
    }).catch((err)=> {
      this.showToast('failed')
      this.orderDetailsFormGroup.getRawValue().agentName = '';
      this.orderDetailsFormGroup.getRawValue().agentType = '';
      this.orderDetailsFormGroup.getRawValue().clientName = '';
      this.orderDetailsFormGroup.getRawValue().address = '';
      this.orderDetailsFormGroup.getRawValue().additialEmailToSe = '';
      this.orderDetailsFormGroup.getRawValue().email = '';
      this.orderDetailsFormGroup.getRawValue().agentPhone = '';
      this.orderDetailsFormGroup.getRawValue().customerName = '';
      this.orderDetailsFormGroup.getRawValue().agentEmail = '';
      this.orderDetailsFormGroup.getRawValue().clientRole = '';
      console.log("err in order Details Error",err);
    });
  }
  //Show toast message
  showToast(message) {
    this.toastComponent.showToast(
      message == 'success'
        ? this.toastMsg.editSuccess
        : this.toastMsg.editFailed
    );
  }
  clientRoleSelect(event){
    this.agentType = event.value;
  }

}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/order-list/order-details-edit/order-details-edit.component.ts